import React, { useState } from 'react';
import { ChevronDown, Lock, Menu, X } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="w-full" data-id="element-71">
      {/* Top Bar - Hidden on mobile */}
      <div className="hidden md:block w-full px-4 md:px-8 py-3" data-id="element-72">
        <div className="max-w-7xl mx-auto flex items-center justify-end gap-4 text-sm" data-id="element-73">
          <nav className="flex items-center gap-7 mr-3" data-id="element-74">
            <a href="https://www.certificationforlaravel.com/about-us" className="text-gray-700 hover:text-gray-900 font-medium transition-colors" data-id="element-75">
              About us
            </a>
            <a href="https://www.certificationforlaravel.com/partners" className="text-gray-700 hover:text-gray-900 font-medium transition-colors" data-id="element-76">
              Partners
            </a>
            <a href="https://www.certificationforlaravel.com/contact" className="text-gray-700 hover:text-gray-900 font-medium transition-colors" data-id="element-77">
              Contact us
            </a>
          </nav>
          <a href="https://20241363.sibforms.com/serve/MUIFANAS23f04HSJO37JBWHUlNyLp8s5OdKZRocAgZ7LTqzN8e6LXKkA8K3Z-1MCiacONo77hxr-_46zRUmhfNXSBORhIxVCu9WpdIUgZWRq6rEZB148taa25TPAaYROP3yub9OdaSBO6I_WVv7YTS-8HuTqEomgTC7POtTHUFAgF2jjnla9KP6KTx7iGsn0fuoaoR9any_2i9Tb" className="px-5 py-2 border border-laravel-red text-laravel-red rounded-md font-medium hover:bg-red-50 transition-colors" data-id="element-78">
            Subscribe newsletter
          </a>
          <a href="https://verifier.certificationforlaravel.org/" className="px-5 py-2 border border-laravel-red text-laravel-red rounded-md font-medium hover:bg-red-50 transition-colors" data-id="element-79">
            Verify Certification
          </a>
          <a href="#" className="px-5 py-2 border border-gray-300 text-gray-700 rounded-md font-medium hover:bg-gray-50 transition-colors flex items-center gap-1.5" data-id="element-80">
            login <Lock className="w-3.5 h-3.5" data-id="element-81" />
          </a>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="w-full px-4 md:px-8 pb-4 md:pb-6 pt-3 md:pt-0" data-id="element-82">
        <div className="max-w-7xl mx-auto bg-white/80 backdrop-blur-sm rounded-2xl shadow-sm border border-gray-100/80 px-4 md:px-8 py-4 md:py-5 flex items-center justify-between" data-id="element-83">
          {/* Logo */}
          <a href="https://www.certificationforlaravel.com" className="flex items-center shrink-0" data-id="element-84">
            <img src="https://cdn.magicpatterns.com/uploads/b4twN3SN9KYb9mfpL5jwbA/image.png" alt="Certification for Laravel" className="h-14 md:h-16 w-auto" data-id="element-85" />
          </a>

          {/* Nav Links - Desktop */}
          <nav className="hidden md:flex items-center gap-12" data-id="element-86">
            <a href="https://www.certificationforlaravel.com/developers" className="flex items-center gap-1.5 text-gray-800 hover:text-laravel-red font-medium transition-colors text-[15px]" data-id="element-87">
              For developers <ChevronDown className="w-4 h-4" data-id="element-88" />
            </a>
            <a href="https://www.certificationforlaravel.com/companies" className="flex items-center gap-1.5 text-gray-800 hover:text-laravel-red font-medium transition-colors text-[15px]" data-id="element-89">
              For companies <ChevronDown className="w-4 h-4" data-id="element-90" />
            </a>
            <a href="https://www.certificationforlaravel.com/educators" className="flex items-center gap-1.5 text-gray-800 hover:text-laravel-red font-medium transition-colors text-[15px]" data-id="element-91">
              For educators <ChevronDown className="w-4 h-4" data-id="element-92" />
            </a>
          </nav>

          {/* CTA - Desktop */}
          <a href="https://certifieddevs.com" className="hidden md:inline-flex px-7 py-2.5 border border-laravel-red text-laravel-red rounded-xl font-bold text-[15px] hover:bg-laravel-red hover:text-white transition-colors" data-id="element-93">
            CertifiedDevs
          </a>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-gray-700 hover:text-gray-900 transition-colors" aria-label="Toggle menu" data-id="element-94">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-95" /> : <Menu className="w-6 h-6" data-id="element-96" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="md:hidden mt-2 bg-white rounded-2xl shadow-lg border border-gray-100 p-6 space-y-4 max-w-7xl mx-auto" data-id="element-97">
            <nav className="space-y-3" data-id="element-98">
              <a href="https://www.certificationforlaravel.com/developers" className="flex items-center justify-between text-gray-800 font-medium py-2 border-b border-gray-100" data-id="element-99">
                For developers <ChevronDown className="w-4 h-4" data-id="element-100" />
              </a>
              <a href="https://www.certificationforlaravel.com/companies" className="flex items-center justify-between text-gray-800 font-medium py-2 border-b border-gray-100" data-id="element-101">
                For companies <ChevronDown className="w-4 h-4" data-id="element-102" />
              </a>
              <a href="https://www.certificationforlaravel.com/educators" className="flex items-center justify-between text-gray-800 font-medium py-2 border-b border-gray-100" data-id="element-103">
                For educators <ChevronDown className="w-4 h-4" data-id="element-104" />
              </a>
            </nav>

            <div className="space-y-3 pt-2" data-id="element-105">
              <a href="https://certifieddevs.com" className="block w-full text-center px-5 py-2.5 border border-laravel-red text-laravel-red rounded-xl font-bold hover:bg-laravel-red hover:text-white transition-colors" data-id="element-106">
                CertifiedDevs
              </a>
              <a href="https://verifier.certificationforlaravel.org/" className="block w-full text-center px-5 py-2.5 border border-laravel-red text-laravel-red rounded-md font-medium hover:bg-red-50 transition-colors text-sm" data-id="element-107">
                Verify Certification
              </a>
              <a href="#" className="block w-full text-center px-5 py-2.5 border border-gray-300 text-gray-700 rounded-md font-medium hover:bg-gray-50 transition-colors text-sm" data-id="element-108">
                login
              </a>
            </div>

            <div className="flex items-center gap-4 pt-2 text-sm text-gray-600" data-id="element-109">
              <a href="https://www.certificationforlaravel.com/about-us" className="hover:text-gray-900" data-id="element-110">
                About us
              </a>
              <a href="https://www.certificationforlaravel.com/partners" className="hover:text-gray-900" data-id="element-111">
                Partners
              </a>
              <a href="https://www.certificationforlaravel.com/contact" className="hover:text-gray-900" data-id="element-112">
                Contact us
              </a>
            </div>
          </div>}
      </div>
    </header>;
}